import {combineReducers} from 'redux';
import counter from './counter';

export default combineReducers({counter});


// WEBPACK FOOTER //
// ./src/state/index.js